import React from 'react';
import Balancer from 'react-wrap-balancer';

import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';

import { UploadedImages } from '@customTypes/UploadedImage';

type Props = {
  title: string;
  description: string;
  backgroundColor?: string;
  color?: string;
  images?: UploadedImages;
  padding?: string;
  className?: string;
};

const Wrapper = styled.div`
  padding-top: 50px;
  @media (min-width: 992px) {
    padding-top: 70px;
  }
  h3 {
    padding-top: 30px;
  }
  p {
    padding-top: 20px;
    opacity: 0.6;
    font-size: 1.1em;
    color: #c7cad0;
    @media (min-width: 992px) {
      font-size: 20px;
    }
    white-space: pre-wrap;
  }
  .images {
    margin-top: 70px;
    margin-bottom: 90px;
    img {
      display: inline-block;
      height: 25px;
      margin-right: 30px;
      margin-bottom: 40px;
      @media (min-width: 992px) {
        height: 40px;
        margin-right: 70px;
      }
      &:last-child {
        margin-right: 0px;
      }
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
`;

const H4 = styled.h4`
  font-size: 26px;
  @media (min-width: 992px) {
    font-size: 36px;
  }
`;
const H3 = styled.h3`
  font-size: 26px;
  @media (min-width: 992px) {
    font-size: 36px;
  }
`;

export const TitleAndDescription: React.FC<Props> = (props) => {
  const {
    // prettier-ignore
    title,
    description,
    backgroundColor,
    color,
    images,
    padding,
    className,
  } = props;

  const Title = !description || images?.data?.length ? H3 : H4;
  return (
    <Container className={className} style={{ backgroundColor, color }}>
      <Wrapper style={padding ? { padding } : {}}>
        <ScrollReveal>
          <Title>
            <Balancer>{title}</Balancer>
          </Title>
        </ScrollReveal>
        {description ? (
          <ScrollReveal>
            <p>
              <Balancer>{description}</Balancer>
            </p>
          </ScrollReveal>
        ) : null}
        {images?.data?.length ? (
          <ScrollReveal>
            <div className="images">
              {images?.data?.map((image, idx) => (
                <img key={image.attributes.url} src={image.attributes.url} alt="Partner Brand" />
              ))}
            </div>
          </ScrollReveal>
        ) : null}
      </Wrapper>
    </Container>
  );
};
